// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__3sJ3g","dropdown":"Select_dropdown__1FYXW"};